module.exports = __webpack_public_path__ + "static/media/wizualizacja-142.d4191ca7.png";